export const ConsumerNetIncomeErrorStyles = {
  banner: 'text-red100 flex justify-center py-4',
}
